import { useAtom } from 'jotai';
import React, { useEffect, useRef } from 'react';
import chefAn from '../assets/img/chef-an.png';
import chefKim from '../assets/img/chef-kim.png';
import chefOh from '../assets/img/chef-oh.png';
import { languageAtom } from '../atoms/languageAtom';

const Team = () => {
  const titleRef = useRef(null);
  const descRef = useRef(null);
  const [language] = useAtom(languageAtom);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
          } else {
            entry.target.classList.remove('show');
          }
        }
      },
      {
        threshold: 0.1, // 10% 이상 보일 때 실행
      }
    );

    // title 관찰 추가
    observer.observe(titleRef.current);

    // desc items 관찰
    const items = descRef.current.children;
    for (const item of Array.from(items)) {
      observer.observe(item);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="team" data-section="team">
      <div className="team__inner">
        <h2 className="team__title" ref={titleRef}>
          Team
        </h2>
        <div className="team__desc" ref={descRef}>
          <div key={'chef-an'} className="team__desc__item">
            <div className="team__content">
              <div className="team__profile">
                <img
                  src={chefAn}
                  alt={'Chef Ahn profile'}
                  className="team__profile__img"
                />
              </div>
              <div className="team__info">
                {language === 'en' ? (
                  <>
                    <h3>Sungjae Anh</h3>
                    <p>
                      Past memories from childhood and
                      <br className="mobile-only" /> diverse experiences gained
                      from working
                      <br className="mobile-only" /> in various restaurants have
                      become sources of inspiration.
                      <br />
                      Based on a deep understanding of ingredients
                      <br className="mobile-only" /> and endless curiosity,
                      <br />
                      Sung Anh started in San Francisco
                      <br className="mobile-only" /> and now operates Mosu Seoul
                      and Mosu Hong Kong.
                    </p>
                  </>
                ) : (
                  <>
                    <h3 className="kr">안성재</h3>
                    <p>
                      어린 시절의 소중한 추억과 여러 레스토랑에서
                      <br className="mobile-only" /> 쌓은 다양한 경험이 영감이
                      되어,
                      <br />
                      재료에 대한 깊은 이해와 끝없는 호기심을 바탕으로
                      <br />
                      샌프란시스코에서 출발하여
                      <br className="mobile-only" /> 모수 서울과 모수 홍콩을
                      운영하고 있습니다.
                      <br />
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>

          <div key={'kim-jin-beom'} className="team__desc__item">
            <div className="team__content">
              <div className="team__profile">
                <img
                  src={chefKim}
                  alt={'kim jin beom profile'}
                  className="team__profile__img"
                />
              </div>
              <div className="team__info">
                {language === 'en' ? (
                  <>
                    <h3>Jinboem Kim</h3>
                    <p>
                      Starting with winning the SOPEXA Korean Sommelier
                      competition,
                      <br />
                      he achieved numerous awards in various competitions
                      <br className="mobile-only" /> and gained diverse
                      experience.
                      <br />
                      He began his wine career with the sommelier team
                      <br className="mobile-only" /> at Sheraton Grand
                      Walkerhill Seoul hotel,
                      <br />
                      and participated as an opening member at Mosu Seoul in
                      2017.
                      <br />
                      Currently,he oversee both the FOH team and beverage team.
                      <br />
                    </p>
                  </>
                ) : (
                  <>
                    <h3 className="kr">김진범</h3>
                    <p>
                      SOPEXA 한국 소믈리애 대회 우승을 시작으로
                      <br className="mobile-only" /> 각종 대회 입상과 다양한
                      경험을 갖고 있습니다.
                      <br />
                      서울 쉐라톤 그랜드 워커힐 호텔 소믈리애 팀에서
                      <br className="mobile-only" /> 와인 업무를 시작했고
                      <br />
                      2017년 모수 서울 오프닝 멤버로 참여해
                      <br className="mobile-only" /> 현재까지 FOH팀과 음료팀을
                      총괄하고 있습니다.
                      <br />
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>

          <div key={'chef-oh'} className="team__desc__item">
            <div className="team__content">
              <div className="team__profile">
                <img
                  src={chefOh}
                  alt={'Chef Oh profile'}
                  className="team__profile__img"
                />
              </div>
              <div className="team__info">
                {language === 'en' ? (
                  <>
                    <h3>Jongil Oh</h3>
                    <p>
                      Chef Oh began his culinary journey
                      <br className="mobile-only" /> after winning first place
                      <br />
                      in a cooking competition for military chefs.
                      <br />
                      He honed his skills at an Italian restaurant
                      <br className="mobile-only" /> and at Merciel,and in 2017,
                      <br />
                      he was recruited as an opening member of Mosu Seoul.
                      <br />
                      Currently he is a head chef, overseeing the kitchen.
                    </p>
                  </>
                ) : (
                  <>
                    <h3 className="kr">오종일</h3>
                    <p>
                      조리병 요리대회 1위를 계기로 요리의 길에 입문하였습니다.
                      <br />
                      이탈리안 레스토랑과 메르씨엘에서 실력을 쌓았고
                      <br className="mobile-only" /> 2017년 모수 서울 오프닝
                      멤버로 영입되어
                      <br />
                      현재는 헤드셰프로 주방을 책임지고 있습니다.
                      <br />
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
